<div class="card-body">
  <h3>{{ 'Request by region' | translate }}</h3>

  @if (!loading) {
    <div class="full-width">
      <app-data-table
        [columns]="tableColumns"
        [data]="regions"
        [config]="tableConfig"
        [totalRecords]="regions.length"
        [loading]="loading"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        (onPage)="onPageChange($event)"
        (onSort)="onSort($event)"
        (onFilter)="onFilter($event)"
        (onSelectAllChange)="onSelectAllChange($event)"
        (onRowClick)="onRowClick($event)"
      >
      </app-data-table>
    </div>
  }

  @if (loading) {
    <app-loading [loading]="loading"/>
  }

  @if (!loading) {
    <div class="summary-section">
      <div class="summary-text">
        {{ 'Total' | translate }}:
        {{ totalRegions }}
        {{ 'regions' | translate }}
      </div>
      <div class="summary-text">
        {{ 'Total area' | translate }}:
        {{ (totalArea | number:'1.0-0') + ' км²' | unitTranslate }}
      </div>
      <!--        <div class="summary-text">-->
      <!--          {{ 'As a percentage of the area of the Republic of lebanon' | translate }}-->
      <!--          :{{ percentage }}%-->
      <!--        </div>-->
    </div>
  }
</div>
